import { render, staticRenderFns } from "./CompanyTask.vue?vue&type=template&id=2e89428a&scoped=true&"
import script from "./CompanyTask.vue?vue&type=script&lang=js&"
export * from "./CompanyTask.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTask.vue?vue&type=style&index=0&id=2e89428a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e89428a",
  null
  
)

export default component.exports